<template>
  <div class="air3DModel">3D控制模型</div>
</template>

<script>
export default {};
</script>

<style>
</style>